export const text = {
  disabled: "Disabled",
  active: "Active",
};
